// @flow

import React from 'react';
import bemify, { toModifiers } from 'bemify-js';

import 'app/viewport/components/Header/MegaMenu.scss';

import type { KindType, RenderCallback } from 'app/common/types';

const bem = bemify('mega-menu');

export type MegaMenuLink = {
  title: string,
  href: string,
  image?: string,
};

export type MegaMenuLinkCollection = {
  title: string,
  titleLink?: string,
  children: MegaMenuLink[],
};

type Props = {
  kind?: KindType,
  links?: MegaMenuLinkCollection[],
  renderHeaderLink: RenderCallback | null,
};

const MegaMenu = ({ kind, links, renderHeaderLink }: Props) => {
  if (!links) {
    return null;
  }

  const collections = links.map(({ title, titleLink, children }, index) => {
    const titleNode = !titleLink ? title : <a href={titleLink}>{title}</a>;

    const enableColumnMode = Boolean(children.length > 6);

    const linkList = children.map((link, idx) => {
      if (link.image) {
        return (
          <li className={bem('__media')} key={idx}>
            <img
              alt={link.title}
              className={bem('__media', '--figure')}
              src={link.image}
            />
            <a className={bem('__media', '--body')} href={link.href}>
              {link.title}
            </a>
          </li>
        );
      }

      return (
        <li className={bem('__link-item')} key={idx}>
          <a className={bem('__link')} href={link.href}>
            {link.title}
          </a>
        </li>
      );
    });

    return (
      <div className={bem('__content-section')} key={index}>
        <h4 className={bem('__title')}>{titleNode}</h4>
        <ul className={bem('__link-list', enableColumnMode ? '--columns' : '')}>
          {linkList}
        </ul>
      </div>
    );
  });

  const headerLink = !renderHeaderLink ? null : (
    <div className={bem('__header-link')}>{renderHeaderLink({})}</div>
  );

  return (
    <div className={bem(toModifiers(kind))}>
      {headerLink}
      <div className={bem('__container')}>{collections}</div>
    </div>
  );
};

export default MegaMenu;
